import { Box, Typography, Button, Grid, Container, Tab, Checkbox } from '@mui/material'
import React, { useEffect, useState } from 'react'
import WTypography from 'Components/whiteTypography'
import { makeGetRequest } from 'utils/api'
import urls from 'utils/urls'
import { useParams, useNavigate } from 'react-router-dom'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'

import Link from '@mui/material/Link'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import AttachmentIcon from '@mui/icons-material/Attachment'
import CreateDocumentsForm from 'Components/CreateDocumentsForm'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import Avatar from '@mui/material/Avatar'
import CustomButton from 'Components/CustomButton/CustomButton'
import { makePostRequest } from 'utils/api'
import styled from '@emotion/styled'
import { convertToUserDateFormate } from 'utils/helpers'
import { useSelector } from 'react-redux'
const useStyles = styled((theme) => ({
  contactBox: {
    display: 'flex',
    padding: '10px 0px',
    alignItems: 'center',
    marginLeft: '40px',
  },
}))

export const FormationDetails = () => {
  const siteUser = useSelector((store) => store.user)

  const { id } = useParams()
  const [parcours, setParcours] = useState({})
  const [value, setValue] = React.useState('1')
  const classes = useStyles()

  let navigate = useNavigate()

  useEffect(() => {
    fetchParcoursDetail()
  }, [])

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  const fetchParcoursDetail = async () => {
    const response = await makeGetRequest(urls.crudParcoursProOperations + id, {}, true)
    if (response.status === 200) {
      setParcours(response.data)
    }
  }
  const displayColumn = (name, value, postfix = '', Icone = '') => (
    <Box display={'flex'} alignItems={'center'}>
      {Icone ? (
        <Typography color="secondary">
          {name} : <Icone />
        </Typography>
      ) : (
        <Typography color="secondary">{name} : </Typography>
      )}
      {name === 'Statut' ? (
        <Typography
          variant="h6"
          sx={{
            color: value === 'actif' ? 'green' : value === 'désactivé' ? 'red' : 'unset',
            marginLeft: '5px',
          }}
        >
          {value}
        </Typography>
      ) : (
        <WTypography variant="h6" sx={{ marginLeft: '5px', color: 'white' }}>
          {value || 'N/A'} {postfix || ''}
        </WTypography>
      )}
    </Box>
  )

  const displayColumn2 = (name, value, postfix = '', Icone = '') => (
    <Box>
      {name === 'Statut' ? (
        <Typography
          variant="h6"
          sx={{
            color: value === 'Actif' ? 'green' : value === 'Inactif' ? 'red' : 'unset',
          }}
        >
          {value}
        </Typography>
      ) : (
        <WTypography variant="h6">
          {value || 'N/A'} {postfix || ''}
        </WTypography>
      )}
      {Icone ? (
        <Typography color="secondary">
          {name} <Icone />
        </Typography>
      ) : (
        <Typography color="secondary">{name}</Typography>
      )}
    </Box>
  )

  const Compétenceclés = (
    <Box border={'1px solid darkgrey'} borderRadius={1} p={1} mt={2}>
      <WTypography variant="h6">Compétence clés</WTypography>
      <Box>
        {parcours.KeyCompetencies_list &&
          parcours.KeyCompetencies_list.length > 0 &&
          parcours.KeyCompetencies_list.map((row) => (
            <Typography key={row.id} sx={{ color: '#adadad' }}>
              {row.CompetencesName}
            </Typography>
          ))}
      </Box>
    </Box>
  )

  const Relations = (
    <Box border={'1px solid darkgrey'} borderRadius={1} p={1} mt={2}>
      <WTypography variant="h6">Contact</WTypography>
      {parcours.ContactLink && (
        <Box
          className={classes.contactBox}
          onClick={() => navigate(`/MesContacts?id=${parcours.ContactLink}`)}
        >
          <Avatar
            sx={{ marginRight: '10px', width: '80px', height: '80px' }}
            alt=""
            src={parcours.contactlink.Picture}
          />
          <Box display="flex" flexDirection="column">
            <Box>
              <WTypography sx={{ fontSize: '24px', textDecoration: 'underline' }}>
                {parcours.contactlink.Nom}
              </WTypography>
            </Box>

            <Box>
              <WTypography sx={{ color: '#ababab', marginTop: '-7px' }}>
                {parcours.contactlink.Titres?.Designation}
              </WTypography>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  )

  const documents = (
    <Box border={'1px solid darkgrey'} borderRadius={1} p={1} mt={2}>
      <BasicTable />
    </Box>
  )

  return (
    <>
      <Container maxWidth="lg">
        <Box display={'flex'} flexDirection={'column'} px={4} py={1}>
          <Box display={'flex'} alignItems={'center'}>
            <WTypography variant="h6" sx={{ color: '#fff' }}>
              {parcours.Name}-{parcours.entreprise?.Name}
            </WTypography>
            <WTypography sx={{ color: '#ababab', marginLeft: '5px' }}>{parcours.City}</WTypography>
          </Box>
          <Box display={'flex'} flexDirection={'row'}>
            <Box
              display={'flex'}
              justifyContent={'start'}
              alignItems={'center'}
              width="180px"
              height="110px"
            >
              <img key="carLogo" width={'70%'} src={parcours.entreprise?.Logo} alt="img" />
            </Box>
            <Box display={'flex'} alignItems={'center'} width="100%">
              <Box
                display="flex"
                justifyContent="start"
                flexDirection="column"
                marginLeft="10px"
                width={'400px'}
              >
                <Box>{displayColumn('Diplomes', parcours.Name)}</Box>
                <Box>
                  {displayColumn(
                    'Date de début',
                    convertToUserDateFormate(siteUser.user, parcours.BeginDate),
                  )}
                </Box>
                <Box>
                  {displayColumn(
                    'Date de fin',
                    convertToUserDateFormate(siteUser.user, parcours.endDate),
                  )}
                </Box>
              </Box>
              <Box width={'400px'} marginLeft={'40px'}>
                <Box>{displayColumn("Statut d'emploi", parcours.Statut)}</Box>
                <Box>{displayColumn('Convention collective', parcours.CollectiveAgre)}</Box>
                <Box>{displayColumn('Ancienneté', parcours.Seniority, 'an(s)')}</Box>
              </Box>
            </Box>
          </Box>
        </Box>

        <Box sx={{ width: '100%', typography: 'body1' }}>
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleChange}>
                <Tab sx={{ color: 'white' }} label="Compétence clés" value="1" />
                <Tab sx={{ color: 'white' }} label="Documents" value="2" />
                <Tab sx={{ color: 'white' }} label="Relations" value="3" />
              </TabList>
            </Box>
            <TabPanel value="1">
              <WTypography variant="h6">{Compétenceclés}</WTypography>
            </TabPanel>
            <TabPanel value="2">{documents}</TabPanel>
            <TabPanel value="3">
              <WTypography variant="h6">{Relations}</WTypography>
            </TabPanel>
          </TabContext>
        </Box>
      </Container>
    </>
  )
}
function BasicTable() {
  const siteUser = useSelector((store) => store.user)

  let params = useParams()
  const [selected, setSelected] = React.useState([])
  const [rowsPerPage, setRowsPerPage] = React.useState(20)
  const [newRows, setNewRows] = useState([])

  useEffect(() => {
    fetchOperations(params.id, 20)
  }, [])
  const fetchOperations = async (id, limit) => {
    const { data, status } = await makeGetRequest(
      `/api/Administrative/documents-operations/?ParcoursPro=${id}`,
      {},
      true,
    )
    if (status === 200) {
      let results = data.results
      setNewRows([...results])
    }
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(rowsPerPage + 20)
    fetchOperations(params.id, rowsPerPage + 20)
  }
  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name)
    let newSelected = []
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name)
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1))
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1))
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      )
    }

    setSelected(newSelected)
  }
  const deleteBulkOperations = async () => {
    if (selected.length === 0) {
      alert('Sélectionner une operation ')
    } else {
      const response = await makePostRequest(
        urls.deleteDocumentsBulkOperations,
        { selected: selected },
        {},
        true,
      )
      if (response.status === 200) {
        fetchOperations(params.id, 20)
        setSelected([])
      }
    }
  }
  return (
    <>
      <Box></Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }} py={5}>
        <Box>
          <Typography variant="h5" pl={1} sx={{ color: 'white' }}>
            Mes documents ({newRows.length})
          </Typography>
        </Box>
        <Box>
          <CreateDocumentsForm params={params} account="ParcoursPro" setNewRows={setNewRows} />
          <CustomButton onClick={deleteBulkOperations}>Supprimer</CustomButton>
        </Box>
      </Box>
      <Box sx={{ color: 'white', paddingBottom: '60px' }}>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650, marginTop: '23px' }} size="small" aria-label="simple table">
            <TableBody>
              {newRows && newRows.length > 0 ? (
                newRows.map((row, index) => (
                  <TableRow
                    key={row.id}
                    sx={{ height: '80px', '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{ display: 'flex', alignItems: 'center' }}
                    >
                      <Checkbox
                        onClick={(event) => handleClick(event, row.id)}
                        color="primary"
                        inputProps={{
                          'aria-labelledby': index,
                        }}
                      />
                      <AttachmentIcon sx={{ padding: '0px 13px', fontSize: '45px' }} />
                      <div>
                        <Link sx={{ fontSize: '16px' }} href={row.Lien}>
                          {row.Lien.split('/').pop()}
                        </Link>
                        <br />
                        Charge le: {convertToUserDateFormate(siteUser.user, row.Datedimport)} -
                        Taille de fichier: {row.FileSize} Mio
                      </div>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={3}>No data yet.</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          {newRows.length > 20 ? (
            <Box display={'flex'} justifyContent={'center'}>
              <Button onClick={handleChangeRowsPerPage}>Load More</Button>
            </Box>
          ) : (
            newRows.length > 20 && (
              <Box display={'flex'} justifyContent={'center'}>
                <Button
                  onClick={() => {
                    fetchOperations(params.id, 20)
                    setRowsPerPage(20)
                  }}
                >
                  Return to initial Size
                </Button>
              </Box>
            )
          )}
        </TableContainer>
      </Box>
    </>
  )
}
